import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./OakmereLogo2.jpg";
import "./NavBar.css";

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="HeadingBanner">
      <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
        <img src={logo} alt="Oakmere Capital logo" />
      </Link>
      <button
        className="HamburgerButton"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className={`PageTabs${menuOpen ? " open" : ""}`}>
        <Link to="/" className="PageTab" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/about" className="PageTab" onClick={() => setMenuOpen(false)}>About Us</Link>
        <Link to="/why-oakmere-capital" className="PageTab" onClick={() => setMenuOpen(false)}>Why Oakmere Capital</Link>
        <Link to="/what-we-offer" className="PageTab" onClick={() => setMenuOpen(false)}>What We Offer</Link>
        <Link to="/our-team" className="PageTab" onClick={() => setMenuOpen(false)}>Our Team</Link>
        <Link to="/contact" className="PageTab" onClick={() => setMenuOpen(false)}>Contact Us</Link>
      </nav>
    </div>
  );
}

export default NavBar;
